import { ReactNode } from 'react';

export interface IPaymentStatus {
    approvalCode: string;
    systemCode: number;
    tranSuccess: boolean;
    avsResp: string;
    tranId: string;
    txnAuth: string;
    account: string;
    cardType: string;
    name: string;
    transArmorToken: number;
    transArmorTokenProviderId: number;
    expiration: number;
    avsData: number;
    tranRespMessage: string;
    sessionId: string;
    cvvResp: string;
    errorCode: number;
    nonAuthReason: string;
}

export interface IPaymentStatusHook {
    attempted: boolean;
    setAttempted: (value: boolean) => void;
    status: IPaymentStatus;
    setStatus: (item: IPaymentStatus) => void;
    resetPayment: () => void;
    due: number;
    setDue: (value: number) => void;
    idiCartId: number;
    setIdiCartId: (value: number) => void;
}

export interface IPaymentContext {
    attempted: boolean;
    setAttempted: (value: boolean) => void;
    status: IPaymentStatus;
    setStatus: (item: IPaymentStatus) => void;
    due: number;
    setDue: (value: number) => void;
    idiCartId: number;
    setIdiCartId: (value: number) => void;
}

export interface IPaymentContextProvider {
    children: ReactNode;
}

export const GenerateDefaultPaymentStatus = () => {
    return {
        approvalCode: '',
        systemCode: 0,
        tranSuccess: false,
        avsResp: '',
        tranId: '',
        txnAuth: '',
        account: '',
        cardType: '',
        name: '',
        transArmorToken: 0,
        transArmorTokenProviderId: 0,
        expiration: 0,
        avsData: 0,
        tranRespMessage: '',
        sessionId: '',
        cvvResp: '',
        errorCode: 0,
        nonAuthReason: ''
    };
};
